import { announceToScreenReader } from '@/utils/screenReaderAnnounce';

function getToastVm(toastEl) {
  return toastEl && toastEl.__vue__;
}

function getToastMessage(toastEl) {
  const vm = getToastVm(toastEl);
  if (vm && vm.data && vm.data.msg) {
    return vm.data.msg;
  }

  const clone = toastEl.cloneNode(true);
  const closeButton = clone.querySelector('.toast-close-button');
  if (closeButton) {
    closeButton.remove();
  }

  return (clone.textContent || '').replace(/\s+/g, ' ').trim();
}

function shouldAddCloseButton(toastEl) {
  const vm = getToastVm(toastEl);
  if (!vm || !vm.data) {
    return true;
  }
  const timeout = vm.data.timeout;
  return timeout === 0 || timeout === '0';
}

function closeToast(toastEl) {
  const vm = getToastVm(toastEl);
  if (vm && typeof vm.close === 'function') {
    vm.close();
    return;
  }
  toastEl.click();
}

function enhanceToastCloseButton(toastEl) {
  if (!toastEl || toastEl.dataset.a11yCloseButton === 'true') {
    return;
  }

  if (!shouldAddCloseButton(toastEl)) {
    return;
  }

  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.className = 'toast-close-button';
  closeButton.setAttribute('aria-label', 'Close notification');
  closeButton.innerHTML = '&times;';

  closeButton.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    closeToast(toastEl);
  });

  closeButton.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      closeToast(toastEl);
    }
  });

  toastEl.appendChild(closeButton);
  toastEl.dataset.a11yCloseButton = 'true';
}

function announceToastMessage(toastEl) {
  if (!toastEl || toastEl.dataset.a11yAnnounced === 'true') {
    return;
  }

  const message = getToastMessage(toastEl);
  if (!message) {
    return;
  }

  const isError = toastEl.classList.contains('toast-error');
  if (isError) {
    toastEl.setAttribute('role', 'alert');
    toastEl.setAttribute('aria-live', 'assertive');
    toastEl.setAttribute('aria-atomic', 'true');
    announceToScreenReader(message, 'assertive');
  } else {
    announceToScreenReader(message, 'polite');
  }

  toastEl.dataset.a11yAnnounced = 'true';
}

function enhanceToast(toastEl) {
  if (!toastEl) {
    return;
  }

  enhanceToastCloseButton(toastEl);
  announceToastMessage(toastEl);
}

function scanToasts() {
  document.querySelectorAll('.toast-container .toast').forEach(enhanceToast);
}

let observer = null;
let scanScheduled = false;

function scheduleToastScan() {
  if (scanScheduled) {
    return;
  }
  scanScheduled = true;
  requestAnimationFrame(() => {
    scanScheduled = false;
    scanToasts();
  });
}

export function initToastAccessibility() {
  if (typeof document === 'undefined' || observer) {
    return;
  }

  observer = new MutationObserver(() => {
    scheduleToastScan();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  scheduleToastScan();
}

export function destroyToastAccessibility() {
  if (observer) {
    observer.disconnect();
    observer = null;
  }
}



// WEBPACK FOOTER //
// ./src/utils/toastAccessibility.js